import {Tooltip, Typography} from '@mui/material';
import PropTypes from 'prop-types';
import React, {useEffect, useRef, useState} from 'react';

/**
 * Wraps a single child and shows a tooltip only when the child's content
 * overflows (scrollWidth > clientWidth). The child controls its own layout;
 * this component only injects a ref and wraps with Tooltip.
 * Matches main-branch behavior: re-measures every render, same tooltip styling.
 */
const TruncatedTooltip = ({title, placement = 'bottom', children}) => {
  const [isTruncated, setIsTruncated] = useState(false);
  const childRef = useRef(null);

  useEffect(() => {
    const el = childRef.current;
    if (el) {
      setIsTruncated(el.scrollWidth > el.clientWidth);
    }
  });

  return (
    <Tooltip
      enterDelay={500}
      title={
        isTruncated ? (
          <Typography sx={{p: '5px'}} fontSize={14}>
            {title}
          </Typography>
        ) : (
          ''
        )
      }
      placement={placement}
      componentsProps={{
        tooltip: {
          sx: {
            borderRadius: '4px',
            backgroundColor: '#27353A',
            py: 0,
            px: 0.2,
          },
        },
      }}
    >
      {React.cloneElement(children, {ref: childRef})}
    </Tooltip>
  );
};

TruncatedTooltip.propTypes = {
  title: PropTypes.string,
  placement: PropTypes.string,
  children: PropTypes.element.isRequired,
};

export default TruncatedTooltip;
